import { ProductThumbnail, Text } from '@cencosud-cencommerce/paris-uikit';

import type { CartOutOfStockItem } from '@/modules/cart/domain/CartOutOfStockItem';
import { SoldBy } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/ProductList';

export const OutOfStockProductItem = ({
  product
}: {
  product: CartOutOfStockItem;
}) => {
  return (
    <div
      data-testid={'product-item'}
      className="co-flex co-gap-3 co-py-3 co-pb-0 tablet_w:co-py-6 tablet_w:co-pb-4"
    >
      <ProductThumbnail
        src={product?.image}
        alt={product?.name ?? 'Producto'}
      />

      <div className="co-grid co-grid-cols co-w-full co-gap-3">
        <div className="co-flex co-justify-between co-gap-3 co-min-w-0 co-h-[45px]">
          <div className="co-flex co-flex-col co-min-w-0 co-gap-1">
            <div className="co-overflow-hidden co-text-ellipsis co-whitespace-nowrap co-flex-shrink-0">
              <Text variant="body2" weight={600}>
                {(product?.name ?? '').toString().toUpperCase()}
              </Text>
            </div>
            <div>
              <SoldBy
                saleTagProps={{
                  label: 'Vendido por',
                  storeName: product?.sellers?.[0] ?? ''
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutOfStockProductItem;
